module.exports = __webpack_public_path__ + "img/Logo.2453bed4.png";